import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Loader } from "@progress/kendo-react-indicators";

const XrefDeleteModal = ({ Xref, userName, isOpen, onClose, onSave, response }) => {
    const [saving, setSaving] = useState(false);

    const handleSubmit = () => {
        setSaving(true)
        onSave(Xref);
    };

    useEffect(() => {
        if (response && response.length) {
            setSaving(false)
        }
    }, [response]);

    return (
        <Dialog title='Delete Xref' onClose={onClose} visible={isOpen}>
            <div style={{ padding: '20px' }}>
                <h2>Are you sure want to delete this record?</h2>
                {userName.length ? <h2>{userName}</h2> : <></>}
                <table className='delete-xref'>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>WorkForce ID Number:</td><td><b>{Xref?.WorkForceIDNum}</b></td>
                        </tr>
                        <tr>
                            <td>Matrix Person ID:</td><td><b>{Xref?.MatrixPersonID}</b></td>
                        </tr>
                        <tr>
                            <td>Matrix Badge ID:</td><td><b>{Xref?.MatrixBadgeID}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='saving-container'>
                {saving && <h2><Loader className='spinner-small' size="small" type={"infinite-spinner"} /><em> Saving...</em></h2>}
            </div>
            <div className='response-container'>
                {response.length
                    ? <><div>{response}</div><button className="k-button" disabled={saving} onClick={onClose}>Close</button></>
                    : <DialogActionsBar>
                        <button className="k-button" disabled={saving} onClick={handleSubmit}>Delete</button>
                        <button className="k-button" disabled={saving} onClick={onClose}>Cancel</button>
                    </DialogActionsBar>
                }
            </div>
        </Dialog>
    );
};

export default XrefDeleteModal;
